var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1594 2.84085C11.0379 -0.279958 5.96155 -0.279958 2.84009 2.84085C-0.28003 5.96166 -0.28003 11.0393 2.84009 14.1602C4.40082 15.7202 6.45044 16.4999 8.50009 16.4999C10.5497 16.4999 12.5987 15.7202 14.1594 14.1602C17.2802 11.0394 17.2802 5.96166 14.1594 2.84085ZM11.8009 10.8586C12.0617 11.1194 12.0617 11.5409 11.8009 11.8017C11.6709 11.9318 11.5001 11.9971 11.3294 11.9971C11.1586 11.9971 10.9879 11.9318 10.8578 11.8017L8.50005 9.44326L6.14295 11.801C6.01223 11.9311 5.84146 11.9965 5.67138 11.9965C5.50065 11.9965 5.32988 11.9311 5.19982 11.801C4.93904 11.5402 4.93904 11.118 5.19982 10.8579L7.55693 8.50016L5.19916 6.1424C4.93838 5.88162 4.93838 5.45942 5.19916 5.1993C5.45929 4.93852 5.88148 4.93852 6.14226 5.1993L8.50002 7.55706L10.8578 5.1993C11.1186 4.93852 11.5401 4.93852 11.8009 5.1993C12.0617 5.45942 12.0617 5.88162 11.8009 6.1424L9.44312 8.50016L11.8009 10.8586Z",
    fill: "#FF5A5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCross);
export default __webpack_public_path__ + "static/media/red-cross.6c65c30c84d5b98241e9ec8a5cbe7ff9.svg";
export { ForwardRef as ReactComponent };